(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioConcursoService',RelatorioConcursoService);

  function RelatorioConcursoService($http, ngsalConfig) {

    var service = {
      exportarExcel: exportarExcel
    };

    return service;

    function exportarExcel(membros) {
      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/corregedoria/relatorioConcurso", membros, {
        responseType: 'blob',
        headers:{
          Accept:'application/vnd.ms-excel'
        }
      }).then(function (response) {
        return response.data;
      });

      return promise;

    }
  }

})();
